import React from 'react';
import { useTranslation } from '@wix/cli-i18n';
import { useGenerationTask } from '../../hooks/use-generation-task.js';
import { useProjectModel } from '../../../../model.js';
import { enableBlocksInProject } from './generate.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../../CompleteGeneration.js';
import type { SiteWidgetType } from '../SiteWidgetWizard.js';
import { BlockGenerationSuccessMessage } from './BlocksGenerationSuccessMessage.js';

export const useAddBlocksSupportToProject = ({
  siteWidgetType,
}: {
  siteWidgetType?: SiteWidgetType;
}) => {
  const { t } = useTranslation();
  const { model } = useProjectModel();

  const extensionType = t(
    'generate_command.site_widget_wizard.blocks.title'
  ).toLowerCase();

  const supportBlocksTask = useGenerationTask(async () => {
    if (siteWidgetType === 'blocks') {
      // No need to update anything if blocks is already set
      if (model.config.blocks) {
        return;
      }

      return enableBlocksInProject(model.projectFolder, model.config);
    }
  }, [siteWidgetType]);

  return [
    <CompleteGeneration
      generationTask={supportBlocksTask}
      extensionType={extensionType}
      successMessage={CompleteGenerationMessage.CustomSuccessMessage({
        comp: <BlockGenerationSuccessMessage />,
      })}
    />,
  ];
};
